/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Chips_CreditsInputs */

const en_landing_chips_credits = /** @type {(inputs: Landing_Chips_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const zh_landing_chips_credits = /** @type {(inputs: Landing_Chips_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分系统`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Landing_Chips_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_chips_credits = /** @type {((inputs?: Landing_Chips_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Chips_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_chips_credits(inputs)
	return zh_landing_chips_credits(inputs)
});
export { landing_chips_credits as "landing.chips.credits" }